import React, { memo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Typography } from "@totalsoft/rocket-ui";
import { Box, Grid } from "@mui/material";
import WrappedLinearProgress from "components/common/WrappedLinearProgress";

const SettingsTyphographyComponent = ({ data, translation }) => {
  const { t } = useTranslation();

  if (data.loading)
    return (
      <Grid container alignItems="center" gap={2}>
        <Typography fontWeight="bold" fontSize="1rem">
          {t(translation.label)}:
        </Typography>
        <Box flexGrow={1}>
          <WrappedLinearProgress color="primary" />
        </Box>
      </Grid>
    );

  return (
    <Grid container gap={0.5}>
      <Typography fontWeight="bold" fontSize="1rem">
        {t(translation.label, {
          data: {
            version: data.version,
            date: t("LONG_DATE", { date: data.date })
          }
        })}
        :
      </Typography>
      <Typography fontSize="1rem">
        {t(translation.value, {
          data: {
            version: data.version,
            date: t("LONG_DATE", { date: data.date })
          }
        })}
      </Typography>
    </Grid>
  );
};

SettingsTyphographyComponent.propTypes = {
  data: PropTypes.object.isRequired,
  translation: PropTypes.object.isRequired
};

export default memo(SettingsTyphographyComponent);
